(function() {
    'use strict';
    
a3_cabin_reports.controller('SeatChangeCtrl', SeatChangeCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name SeatChangeCtrl
    * @description 
    *  Manages the seat change Modal View
    * @ngInject
    */
function SeatChangeCtrl(changedSeat, report, paxInfo, PaxInfoFactory, $scope, $uibModalInstance) {
        var paxInfo = paxInfo;
        var allPassengers = getPassengers();
        $scope.allPassengers = allPassengers;
        $scope.clearChangedSeatsRemarks = clearChangedSeatsRemarks;

		var result = {};

		if (changedSeat == null) {
            $scope.editMode = false;
			result.Object = null;
			result.isInsertMode = true;
		} else {
            $scope.editMode = true;
            result.Object = Object.assign({}, changedSeat);
            result.Object.check = true;
			result.isInsertMode = false;
		}

        $scope.changedSeat = result.Object;
        
        $scope.showSeatChangeWarning = false;
        $scope.showSeatChangeError = false;
        $scope.submitSeatChange = submitSeatChange;
        $scope.saveSeatChange = saveSeatChange;
        $scope.cancel = cancel;

		

        /**
         * Clear Field
         * @memberof SeatChangeCtrl
         */
        function clearField(target, fieldName) {
			if (target[fieldName] == null || target[fieldName] == '') return false;
			bootbox.dialog({
				message: "Please confirm that you wish to clear this field",
				title: "<strong>Attention<strong>",
				buttons: {
					cancel: {
						label: "Cancel",
						className: "btn-default",
						callback: function() {}
					},
					ok: {
						label: "Ok",
						className: "btn-warning",
						callback: function() {
							target[fieldName] = null;
							$scope.$apply();
							return true;
						}
					}
				}
			});
        }
        
        /**
         * fix any input into 000A format
         * @memberof SeatChangeCtrl
         */
        function formatSeatInput(){
			var missingZeroes = 4 - $scope.changedSeat.NewSeatNo.length;
			for (var i=0; i<missingZeroes; i++)
                $scope.changedSeat.NewSeatNo = '0' + $scope.changedSeat.NewSeatNo;
		}

        /**
         * Clear Seat Change remarks
         * @memberof SeatChangeCtrl
         * @param {object} changedSeat
         */
        function clearChangedSeatsRemarks(changedSeat) {
			clearField(changedSeat, "Remarks");
		}
        
        /**
         * Gets called when user hits submit. checks input then saves
         * @memberof SeatChangeCtrl
         */
        function submitSeatChange() {
            $scope.showSeatChangeError = false;
            if (!isSeatAvailable()){
				return;
            }
			saveSeatChange();
        }
        
        /**
         * Save the new seat change to the report
         * @memberof SeatChangeCtrl
         */
        function saveSeatChange(){
			result.Object = $scope.changedSeat;
            for (var i=0;i<allPassengers.length;i++){
                if (allPassengers[i].SeatNo == result.Object.OriginalSeatNo){
                    result.Object.UCI = allPassengers[i].UCI;
                    result.Object.PNR = allPassengers[i].PNR;
                    result.Object.Name = allPassengers[i].Fullname;
                }
            }
			$uibModalInstance.close(result);
		}

        /**
         * Check if seat exists and is empty. fires warnings and errors
         * @memberof SeatChangeCtrl
         * @return {boolean} isSeatAvailable
         */
        function isSeatAvailable(){
            $scope.changedSeat.NewSeatNo = $scope.changedSeat.NewSeatNo.toUpperCase();
            formatSeatInput();

            if (paxInfo){
				for(var i=0;i<paxInfo.Seatmap.length;i++){
					for(var j=0;j<paxInfo.Seatmap[i].Columns.length;j++){
						if (paxInfo.Seatmap[i].Columns[j].SeatNo == $scope.changedSeat.NewSeatNo){
							if (paxInfo.Seatmap[i].Columns[j].IsEmptySeat && !IsAlreadyGivenSeat($scope.changedSeat.NewSeatNo)){
								return true;
							}
							$scope.showSeatChangeWarning = true;
							return false;
						}
					}
				}
			}

			//not found in seatmap
			$scope.showSeatChangeError = true;
			$scope.changedSeat.NewSeatNo = '';
			return false;
        }

        function IsAlreadyGivenSeat(newSeatNo){
            return  report.ChangedSeats.some(function (item) {
                return  item.NewSeatNo == newSeatNo;
            }); 
        }
        
        /**
         * Close modal
         * @memberof SeatChangeCtrl
         */
        function cancel() {
			$uibModalInstance.close(null);
        }
        
        /**
         * Get all passengers and have not been changed already
         * @memberof SeatChangeCtrl
         * @return {array} passengers
         */
        function getPassengers(){
            var passengersList = [];
            if (paxInfo){
                for(var i=0;i<paxInfo.Seatmap.length;i++){
                    for(var j=0;j<paxInfo.Seatmap[i].Columns.length;j++){
                        var alreadyChanged = false;
                        for (var k=0;k<report.ChangedSeats.length;k++){
                            if (report.ChangedSeats[k].UCI == paxInfo.Seatmap[i].Columns[j].UCI &&
                                report.ChangedSeats[k].PNR == paxInfo.Seatmap[i].Columns[j].PNR &&
                                report.ChangedSeats[k].OriginalSeatNo == paxInfo.Seatmap[i].Columns[j].SeatNo){
                                    alreadyChanged = true;
                            }
                        }
                        if (!alreadyChanged && paxInfo.Seatmap[i].Columns[j].SeatNo && !paxInfo.Seatmap[i].Columns[j].IsEmptySeat){
                            passengersList.push(paxInfo.Seatmap[i].Columns[j]);
                        }
                    }
                }
            }
            return passengersList;
        }
	}

})();